// extracted by mini-css-extract-plugin
export var header = "_g6-0";